module.exports = __webpack_public_path__ + "static/media/19.fbaf140.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/19.wav
// module id = b+s+
// module chunks = 0